<template>
  <div class="wrapper">
    <h3 style="font-size: 20px; font-weight: 500;">{{ $t('signed_document_upload') }}</h3>
    <p>{{ $t('fill_required_fields') }}</p>
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-layout class="form-wrapper" wrap>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="$store.state.documents.registrationId"
            :label="$t('registration_id')"
            :rules="[required]"
            name="registration_id"
            autofocus
          />
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn type="submit" color="primary" class="primary-btn">{{ $t('continue') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import formMixin from '../mixins/form-mixin';

export default {
  name: 'SignedDocumentUploadForm',

  mixins: [formMixin],

  created() {
    this.storeClientType('');
  },

  methods: {
    ...mapMutations({
      storeClientType: 'clients/storeType',
    }),

    onSubmit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$router.push({ name: 'choose-files' });
    },
  },
};
</script>
